import { render, staticRenderFns } from "./HasIntercom.vue?vue&type=template&id=63ba5d78&"
import script from "./HasIntercom.vue?vue&type=script&lang=ts&"
export * from "./HasIntercom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports